import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmCloseDialogComponent } from './confirm-close-dialog.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ConfirmCloseDialogComponent],
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatSelectModule, TranslateModule],
    exports: [ConfirmCloseDialogComponent],
})
export class ConfirmCloseDialogModule {}
